module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/google-play-badge-f86dc85123b3e42a5da3901ff7fe24a9.svg";